/* eslint-disable class-methods-use-this */

interface LogRequest {
	sessionId?: string;
	error: unknown;
	stack?: unknown;
	errorInfo?: unknown;
	url: string;
	clientVersion: number;
	windowSize: string;
	browser?: string;
	browserVersion?: string;
	os?: string;
}

export interface ErrorLogInfoEntry {
	timestamp: number;
	error: string;
}

export class LoggingService {
	async log(data: LogRequest): Promise<void> {
		try {
			const response = await fetch(`${CHAT_API_URL}/log`, {
				method: 'POST',
				headers: {
					'x-api-key': CHAT_API_KEY,
				},
				body: JSON.stringify(data),
			});

			if (!response.ok) {
				return Promise.reject(response.statusText);
			}

			return Promise.resolve();
		} catch (error) {
			return Promise.reject(error);
		}
	}
}

export default LoggingService;
